import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import { getPaletteAsRawColors } from 'owa-theme';

const styles = require('./RoomIcon.scss');
const classNames = require('classnames');
export interface RoomIconProps {
    backgroundColor?: string;
    colorScheme?: ColorScheme;
    className?: string;
}

/**
 * This is the room coin shown when displaying the room persona.
 */
export default function RoomIcon(props: RoomIconProps) {
    const { colorScheme, backgroundColor } = props;
    const coinBackgroundStyle = {
        backgroundColor:
            backgroundColor ||
            (colorScheme
                ? getOptimalTextColorString(
                      getPaletteAsRawColors().white,
                      colorScheme,
                      colorScheme.calPrimary
                  )
                : getPaletteAsRawColors().themeSecondary),
    };
    return (
        <div
            style={coinBackgroundStyle}
            className={classNames(styles.roomIconContainer, props.className)}>
            <Icon iconName={ControlIcons.Door} className={styles.roomIcon} />
        </div>
    );
}
